import { render, staticRenderFns } from "./LoadMoreRecords.vue?vue&type=template&id=6733dbca&scoped=true&"
import script from "./LoadMoreRecords.vue?vue&type=script&lang=js&"
export * from "./LoadMoreRecords.vue?vue&type=script&lang=js&"
import style0 from "./LoadMoreRecords.vue?vue&type=style&index=0&id=6733dbca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6733dbca",
  null
  
)

export default component.exports